import React, { useState, useContext, useEffect } from "react";
import { Magic } from "magic-sdk";
import { navigate, Link } from "gatsby";
import { toast } from "react-toastify";
import Loading from "../../components/Loading";
import client from "../../apollo/client";
import { AuthUserContext } from "../../context/AuthUser";
import { apiBase } from "../../services/appenv";
import { getCurrentUser } from "../../services/api";


let magic = null;

const Login = () => {
  const { setAuthUser } = useContext(AuthUserContext);

  const [email, setEmail] = useState("");
  const [magicLinkLoading, setMagicLinkLoading] = useState(false);
  const [magicLinkStatus, setMagicLinkStatus] = useState("");

  const getLocalStorage = (key) => {
    if (typeof window !== "undefined") {
      return localStorage.getItem(key);
    }
    return null;
  };

  const removeLocalStorage = (key) => {
    if (typeof window !== "undefined") {
      localStorage.removeItem(key);
    }
  };

  const clearUserSession = () => {
    removeLocalStorage("token");
    setAuthUser({ logged: false, user: {} });
    client.clearStore();
  };

  useEffect(() => {
    const token = getLocalStorage("token");

    if (token) {
      navigate("/home");
    } else {
      client.clearStore();
      removeLocalStorage("token");
      navigate("/login-magic");
    }

    if (typeof window !== "undefined") {
      magic = new Magic(process.env.GATSBY_MAGIC_PUBLISHABLE_KEY);
    }
  }, [navigate, client]);


  const handleMagicLinkLogin = async (e) => {
    e.preventDefault();

    if (typeof window === "undefined" || !magic) {
      toast.error("Cannot perform authentication in this environment");
      return;
    }

    setMagicLinkLoading(true);
    setMagicLinkStatus("Initiating Magic Link login process...");

    try {
      setMagicLinkStatus("Sending magic link to your email...");
      const didToken = await magic.auth.loginWithMagicLink({ email });
      setMagicLinkStatus(
        "Token received from Magic. Authenticating with Strapi..."
      );

      const url = `${apiBase}/api/auth/magic/callback`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id_token: didToken }),
        credentials: "include",
      });

      if (!response.ok) {
        let errorMessage = `Error ${response.status}: ${response.statusText}`;
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorData.error || errorMessage;
        } catch (e) {}
        throw new Error(errorMessage);
      }

      const data = await response.json();
      setMagicLinkStatus("Processing...");

      if (data.user && data.user.blocked) {
        clearUserSession();
        toast.error("Account not yet activated.");
        setMagicLinkStatus("");
        return;
      }

      localStorage.setItem("token", data.jwt);
      // localStorage.setItem("user_data", JSON.stringify(data.user));

      try {
        const userDetails = await getCurrentUser(data.jwt);
        const { role, typecustomer, user_type } = userDetails;

        if (userDetails.blocked) {
          clearUserSession();
          toast.error("Account not yet activated.");
          setMagicLinkStatus("");
          return;
        }

        if (role?.id) {
          navigate(role.id === 4 ? "/orders" : "/home");

          setAuthUser({
            logged: true,
            typeCustomer: typecustomer ? typecustomer : "",
            role: role.id,
            type: user_type ? user_type?.name : "",
            user: { ...data.user, confirmed: typecustomer ? typecustomer : "" },
          });

          setMagicLinkStatus("Successful login!");
          toast.success("Successful login");
        } else {
          clearUserSession();
          toast.error("The user does not have access");
          setMagicLinkStatus("");
        }
      } catch (error) {
        clearUserSession();
        toast.error("Failed to fetch user details");
        setMagicLinkStatus("");
      }
    } catch (error) {
      clearUserSession();
      toast.error("User not found, make sure the email is correct.");
      setMagicLinkStatus("");
    } finally {
      setMagicLinkLoading(false);
    }
  };

  return (
    <>
      {magicLinkLoading && <Loading />}
      {magicLinkLoading && (
        <div className="message-loading">
          <div className="loading loading-card"></div>
          <p>Please wait a moment to prepare your textile library.</p>
        </div>
      )}
      <section className="container container-card-login">
        <h2>Login</h2>
        <div className="container-card-login__content">
          <h3
            style={{
              textAlign: "center",
              fontWeight: "400",
              marginBlock: "20px",
            }}
          >
            Log in with Magic Link
          </h3>
          <form onSubmit={handleMagicLinkLogin} noValidate>
            <div className="container-card-login__input">
              <input
                type="email"
                name="magicEmail"
                placeholder="E-mail address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="u-width-100"
                style={{
                  height: "40px",
                  height: "44px",
                  border: "1px solid black",
                }}
                required
                disabled={magicLinkLoading}
              />
            </div>

            <button
              type="submit"
              disabled={magicLinkLoading}
              className="btn btn-primary"
              style={{ margin: "auto", width: "250px" }}
            >
              {magicLinkLoading ? (
                <div
                  className="loading"
                  style={{ width: "30px", height: "30px" }}
                ></div>
              ) : (
                "Send Magic Link"
              )}
            </button>
          </form>

          <p style={{ marginBottom: "0", marginTop: "1.5em", color: "black" }}>
            Please agree to the{" "}
            <Link
              to="/terms-and-conditions"
              style={{ textDecoration: "underline", color: "black" }}
            >
              terms of service
            </Link>{" "}
            and proceed.
          </p>

          <p style={{ marginBottom: "10px", marginTop: "1em", color: "black" }}>
            No account?{" "}
            <Link
              to="/register-new"
              className=""
              style={{ textDecoration: "underline", color: "black" }}
            >
              Pre-register
            </Link>{" "}
            now.
          </p>
        </div>
      </section>
    </>
  );
};

export default Login;